import { defaultSWRConfig, getSWRFetcher } from '@shared/apiv2/api'
import useSWR from 'swr'

export const useOrders = () => useSWR('/admin/orders', getSWRFetcher, defaultSWRConfig)
export const useOrder = (id?: string | number) => useSWR(`/admin/orders/${id}`, getSWRFetcher, defaultSWRConfig)

export const useAdminUser = (fetch?: boolean) => useSWR(fetch ? '/admin/user' : null, getSWRFetcher, defaultSWRConfig)

export const useServiceTypes = () => useSWR('/admin/orders/services', getSWRFetcher, defaultSWRConfig)
